<div
    class="avi-checkbox-container-group clr-wrapper"
    [ngClass]="{ 'avi-checkbox-container-group--no-margin-top': noMarginTop }"
>
    <fieldset>
        <legend
            *ngIf="label"
            class="avi-checkbox-container-group__label"
        >
            {{ label }}
        </legend>
        <ng-content></ng-content>
    </fieldset>
</div>
